import {StyledButton} from './button.styles'

export const Button = ({text, onClick}: {text:string, onClick: () => void}) => (
	<StyledButton onClick={onClick}>{text}</StyledButton>
)